import React, { Component }  from 'react';
import assets from '../../../helpers/Assets';
import './GoPlus.scss';
import ARROW_DARK from '../assets/arrow1.png';
import ARROW_LIGHT from '../assets/arrow2.png';


class GoPlus extends Component {
  static defaultProps = {
    disabled : false
  }

  state = {
  }

  componentWillMount = () => {
  }

  componentDidMount = () => {

  }

  render() {
    const { style, theme } = this.props;
    return (
      <a className='go_plus_a' style={style || {}} href='https://gopluslabs.io/' target='_blank' rel="noopener noreferrer">
        <img alt='' className='go_plus_img' src={assets.GO_PLUS}></img>
        <div className='go_plus_text' style={{color: theme === 'dark' ? '#161616' : 'white'}}>Powered by GO+ Security</div>
        <img alt='' className='go_plus_arrow' src={theme === 'dark' ? ARROW_DARK: ARROW_LIGHT}></img>
      </a>
    );
  }
}

export default GoPlus;

